import { render, staticRenderFns } from "./TraineeCapacitationsTopics.vue?vue&type=template&id=3382ddc1&"
import script from "./TraineeCapacitationsTopics.vue?vue&type=script&lang=js&"
export * from "./TraineeCapacitationsTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports